import { PublicClientApplication } from "@azure/msal-browser";

export interface ClientApiProps {
  baseUrl: string;
  b2cDomainName: string;
  msalClient: PublicClientApplication;
  apiPortal: string
}
